  <!-- Footer Start -->
  <footer class="ct-footer">
    <!-- Top Footer -->
    <div class="container">
      <div class="footer-top">
        <div class="footer-logo">
          <img src="assets/img/logo.png" alt="logo">
        </div>
        <div class="footer-buttons">
          <a href="#"> <img src="assets/img/android.png" alt="download it on the app store"></a>
          <a href="#"> <img src="assets/img/ios.png" alt="download it on the app store"></a>
        </div>
      </div>
    </div>

    <!-- Middle Footer -->
    <div class="footer-middle">
      <div class="container">
        <div class="row">
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-12 footer-widget">
            <h5 class="widget-title">Information</h5>
            <ul>
              <li> <a routerLink='/'>Home</a> </li>
              <li> <a routerLink='/blog-grid'>Blog</a> </li>
              <li> <a routerLink='/about'>About Us</a> </li>
              <li> <a routerLink='/menu-v1'>Menu</a> </li>
              <li> <a routerLink='/contact'>Contact Us</a> </li>
            </ul>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-12 footer-widget">
            <h5 class="widget-title">Top Items</h5>
            <ul>
              <li> <a href="#">Pepperoni</a> </li>
              <li> <a href="#">Swiss Mushroom</a> </li>
              <li> <a href="#">Barbeque Chicken</a> </li>
              <li> <a href="#">Vegetarian</a> </li>
              <li> <a href="#">Ham & Cheese</a> </li>
            </ul>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-12 footer-widget">
            <h5 class="widget-title">Others</h5>
            <ul>
              <li> <a routerLink='/checkout'>Checkout</a> </li>
              <li> <a routerLink='/cart'>Cart</a> </li>
              <li> <a routerLink='/menu-item-v1'>Product</a> </li>
              <li> <a routerLink='/locations'>Locations</a> </li>
              <li> <a routerLink='/legal'>Legal</a> </li>
            </ul>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 footer-widget">
            <h5 class="widget-title">Social Media</h5>
            <ul class="social-media">
              <li> <a href="#" class="facebook"> <i class="fab fa-facebook-f"></i> </a> </li>
              <li> <a href="#" class="pinterest"> <i class="fab fa-pinterest-p"></i> </a> </li>
              <li> <a href="#" class="google"> <i class="fab fa-google"></i> </a> </li>
              <li> <a href="#" class="twitter"> <i class="fab fa-twitter"></i> </a> </li>
            </ul>
            <div class="footer-offer">
              <p>Signup and get exclusive offers and coupon codes</p>
              <a href="#" class="btn-custom btn-sm shadow-none">Sign Up</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer Bottom -->
    <div class="footer-bottom">
      <div class="container">
        <ul>
          <li> <a href="https://cygnuspay.com/privacy.php">Privacy Policy</a> </li>
          <li> <a href="#">Refund Policy</a> </li>
          <li> <a href="#">Cookie Policy</a> </li>
          <li> <a href="http://cygnuspay.com/galaxy_pos_term_conditions.php">Terms & Conditions</a> </li>
        </ul>
        <div class="footer-copyright">
          <p> Copyright &copy; 2020 <a href="#">AndroThemes</a> All Rights Reserved. </p>
          <a href="#" class="back-to-top">Back to top <i class="fas fa-chevron-up"></i> </a>
        </div>
      </div>
    </div>

  </footer>
  <!-- Footer End -->
<!-- Customize Modal Start -->
<div class="modal fade" id="customizeModal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header modal-bg" style="background-image: url('assets/img/blog/11.jpg')">

          <button type="button" class="close-btn" data-dismiss="modal" aria-label="Close">
            <span></span>
            <span></span>
          </button>

        </div>
        <div class="modal-body">

          <div class="customize-meta">
            <h4 class="customize-title">Pepperoni Pizza <span class="custom-primary">13.99$</span> </h4>
            <p>
              Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy
            </p>
          </div>

          <div class="customize-variations">

            <div class="customize-size-wrapper">
              <h5>Size: </h5>
              <div class="customize-size active">
                11"
              </div>
              <div class="customize-size">
                16"
              </div>
              <div class="customize-size">
                21"
              </div>
            </div>

            <div class="row">

              <!-- Variation Start -->
              <div class="col-lg-4 col-12">
                <div class="customize-variation-wrapper">
                  <i class="flaticon-bread-roll"></i>
                  <h5>Dough</h5>
                  <div class="customize-variation-item" data-price="0.00">
                    <div class="custom-control custom-radio">
                      <input type="radio" checked id="regularDough" name="dough" class="custom-control-input">
                      <label class="custom-control-label" for="regularDough">Regular</label>
                    </div>
                    <span>+0.00$</span>
                  </div>
                  <div class="customize-variation-item" data-price="2.00">
                    <div class="custom-control custom-radio">
                      <input type="radio" id="thinDough" name="dough" class="custom-control-input">
                      <label class="custom-control-label" for="thinDough">Hand Flipped</label>
                    </div>
                    <span>+2.00$</span>
                  </div>
                  <div class="customize-variation-item" data-price="4.00">
                    <div class="custom-control custom-radio">
                      <input type="radio" id="multiGrainDough" name="dough" class="custom-control-input">
                      <label class="custom-control-label" for="multiGrainDough">Multi Grain</label>
                    </div>
                    <span>+4.00$</span>
                  </div>
                </div>
              </div>
              <!-- Variation End -->

              <!-- Variation Start -->
              <div class="col-lg-4 col-12">
                <div class="customize-variation-wrapper">
                  <i class="flaticon-pizza-slice"></i>
                  <h5>Crust</h5>
                  <div class="customize-variation-item" data-price="4.00">
                    <div class="custom-control custom-radio">
                      <input type="radio" id="cheeseCrust" name="crust" class="custom-control-input">
                      <label class="custom-control-label" for="cheeseCrust">Cheese</label>
                    </div>
                    <span>+4.00$</span>
                  </div>
                  <div class="customize-variation-item" data-price="3.25">
                    <div class="custom-control custom-radio">
                      <input type="radio" id="butterCrust" name="crust" class="custom-control-input">
                      <label class="custom-control-label" for="butterCrust">Butter</label>
                    </div>
                    <span>+3.25$</span>
                  </div>
                </div>
              </div>
              <!-- Variation End -->

              <!-- Variation Start -->
              <div class="col-lg-4 col-12">
                <div class="customize-variation-wrapper">
                  <i class="flaticon-pizza-and-cutted-slice"></i>
                  <h5>Add</h5>
                  <div class="customize-variation-item" data-price="2.00">
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" id="addChicken">
                      <label class="custom-control-label" for="addChicken">Chicken</label>
                    </div>
                    <span>+2.00$</span>
                  </div>
                  <div class="customize-variation-item" data-price="1.20">
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" id="addFourCheese">
                      <label class="custom-control-label" for="addFourCheese">Four Cheese</label>
                    </div>
                    <span>+1.20$</span>
                  </div>
                  <div class="customize-variation-item" data-price="0.75">
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" id="addFreshMushroom">
                      <label class="custom-control-label" for="addFreshMushroom">Fresh Mushroom</label>
                    </div>
                    <span>+0.75$</span>
                  </div>
                  <div class="customize-variation-item" data-price="0.25">
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" id="addBellPepper">
                      <label class="custom-control-label" for="addBellPepper">Bell Peppers</label>
                    </div>
                    <span>+0.25$</span>
                  </div>
                </div>
              </div>
              <!-- Variation End -->

            </div>
          </div>

          <div class="customize-controls">
            <div class="qty">
              <span class="qty-subtract"><i class="fas fa-minus"></i></span>
              <input type="text" name="qty" value="1">
              <span class="qty-add"><i class="fas fa-plus"></i></span>
            </div>
            <div class="customize-total" data-price="13.99">
              <h5>Total Price: <span class="final-price custom-primary">13.99 <span>$</span> </span> </h5>
            </div>
          </div>

          <button type="button" class="btn-custom btn-block">Order Now</button>

        </div>
      </div>
    </div>
  </div>
  <!-- Customize Modal End -->

  <!-- Cart Sidebar Start -->
  <div class="cart-sidebar-wrapper">
    <aside class="cart-sidebar">
      <div class="cart-sidebar-header">
        <h3>Your Cart</h3>
        <div class="close-btn cart-trigger close-dark">
          <span></span>
          <span></span>
        </div>
      </div>
      <div class="cart-sidebar-body">
        <div class="cart-sidebar-scroll">
          <div class="cart-sidebar-item">
            <div class="media">
              <a routerLink='/menu-item-v1'><img src="assets/img/prods-sm/1.png" alt="product"></a>
              <div class="media-body">
                <h5> <a routerLink='/menu-item-v1' title="Pepperoni">Pepperoni</a> </h5>
                <span>4x 9.99$</span>
              </div>
            </div>
            <div class="cart-sidebar-item-meta">
              <span>14 Inches</span>
              <span>Extra Cheese</span>
              <span>Cheese Crust</span>
            </div>
            <div class="cart-sidebar-price">
              36.99$
            </div>
            <div class="close-btn">
              <span></span>
              <span></span>
            </div>
          </div>
          <div class="cart-sidebar-item">
            <div class="media">
              <a routerLink='/menu-item-v1'><img src="assets/img/prods-sm/2.png" alt="product"></a>
              <div class="media-body">
                <h5> <a routerLink='/menu-item-v1' title="Vegetarian">Vegetarian</a> </h5>
                <span>2x 5.99$</span>
              </div>
            </div>
            <div class="cart-sidebar-item-meta">
              <span>14 Inches</span>
            </div>
            <div class="cart-sidebar-price">
              12.99$
            </div>
            <div class="close-btn">
              <span></span>
              <span></span>
            </div>
          </div>
          <div class="cart-sidebar-item">
            <div class="media">
              <a routerLink='/menu-item-v1'><img src="assets/img/prods-sm/3.png" alt="product"></a>
              <div class="media-body">
                <h5> <a routerLink='/menu-item-v1' title="Italian Jalapeno Special">Italian Jalapeno Special</a> </h5>
                <span>1x 12.99$</span>
              </div>
            </div>
            <div class="cart-sidebar-item-meta">
              <span>14 Inches</span>
              <span>Extra Cheese</span>
              <span>Cheese Crust</span>
            </div>
            <div class="cart-sidebar-price">
              12.99$
            </div>
            <div class="close-btn">
              <span></span>
              <span></span>
            </div>
          </div>
          <div class="cart-sidebar-item">
            <div class="media">
              <a routerLink='/menu-item-v1'><img src="assets/img/prods-sm/4.png" alt="product"></a>
              <div class="media-body">
                <h5> <a routerLink='/menu-item-v1' title="Barbeque Chicken">Barbeque Chicken</a> </h5>
                <span>4x 9.99$</span>
              </div>
            </div>
            <div class="cart-sidebar-item-meta">
              <span>12 Inches</span>
              <span>Extra Cheese</span>
              <span>Cheese Crust</span>
              <span>Added Chicken</span>
            </div>
            <div class="cart-sidebar-price">
              36.99$
            </div>
            <div class="close-btn">
              <span></span>
              <span></span>
            </div>
          </div>
          <div class="cart-sidebar-item">
            <div class="media">
              <a routerLink='/menu-item-v1'><img src="assets/img/prods-sm/5.png" alt="product"></a>
              <div class="media-body">
                <h5> <a routerLink='/menu-item-v1' title="Four Cheese">Four Cheese</a> </h5>
                <span>2x 5.99$</span>
              </div>
            </div>
            <div class="cart-sidebar-item-meta">
              <span>12 Inches</span>
              <span>Added Chicken</span>
            </div>
            <div class="cart-sidebar-price">
              12.99$
            </div>
            <div class="close-btn">
              <span></span>
              <span></span>
            </div>
          </div>
          <div class="cart-sidebar-item">
            <div class="media">
              <a routerLink='/menu-item-v1'><img src="assets/img/prods-sm/6.png" alt="product"></a>
              <div class="media-body">
                <h5> <a routerLink='/menu-item-v1' title="Swiss Mushroom">Swiss Mushroom</a> </h5>
                <span>1x 12.99$</span>
              </div>
            </div>
            <div class="cart-sidebar-item-meta">
              <span>12 Inches</span>
              <span>Extra Cheese</span>
              <span>Cheese Crust</span>
              <span>Added Chicken</span>
            </div>
            <div class="cart-sidebar-price">
              12.99$
            </div>
            <div class="close-btn">
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </div>
      <div class="cart-sidebar-footer">
        <h4>Total: <span>299.99$</span> </h4>
        <a href="#" class="btn-custom">Checkout</a>
      </div>
    </aside>
    <div class="cart-sidebar-overlay cart-trigger">
    </div>
  </div>
  <!-- Cart Sidebar End -->

  <!-- Search Form Start-->
  <div class="search-form-wrapper">
    <div class="search-trigger close-btn">
      <span></span>
      <span></span>
    </div>
    <form class="search-form" method="post">
      <input type="text" placeholder="Search..." value="">
      <button type="submit" class="search-btn">
        <i class="flaticon-magnifying-glass"></i>
      </button>
    </form>
  </div>
  <!-- Search Form End-->